// extracted by mini-css-extract-plugin
module.exports = {"container":"business-resource-logo-usage_container__3mV5p"};